import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

// Components
import { TertiaryButton } from 'wg-fe-ui';

interface Props {
  onClick: () => void;
  allSelected: boolean;
  disabled?: boolean;
}

const SelectAllContainer: React.FC<React.PropsWithChildren<Props>> = ({
  onClick,
  allSelected,
  disabled,
  ...otherProps
}) => {
  const { t } = useTranslation();

  return (
    <Wrapper data-test-id="ProdFac_SelectAllContainer" {...otherProps}>
      {!disabled && (
        <StyledTertiaryButton
          onClick={onClick}
          data-test-id={`ADVISORY-CONVO_SELECTION-VIEW_SELECT-ALL-BUTTON`}
        >
          {allSelected ? t('Deselect all') : t('Select all')}
        </StyledTertiaryButton>
      )}
    </Wrapper>
  );
};

const StyledTertiaryButton = styled(TertiaryButton)`
  font-size: 1.8rem;

  &:focus {
    outline: none;
  }
`;

const Wrapper = styled.div`
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding: 1.6rem 0 1.6rem 1.6rem;
`;

export default SelectAllContainer;
